import { useState } from "react";
import useApi from "./useApi";
import { API_ROUTES } from "lib/constants/api-constants";
import { ADMIN_DASHBOARD_TILES_METADATA } from "lib/constants/widget-constants";

interface DashboardState {
  loading: boolean;
  error: string | null;
  getAdminDashboardData: () => void;
  getDashboardWidgetData: () => void;
  dashboardWidgets: DashboardWidget[];
}

const useDashboard = (): DashboardState => {
  const [error, setError] = useState<string | null>(null);
  const [dashboardWidgets, setDashboardWidgets] = useState<DashboardWidget[]>(
    []
  );
  const {
    getData: getAdminDashboardDataRequest,
    loading: getAdminDashboardDataLoading,
  } = useApi();

  const {
    getData: getDashboardWidgetDataRequest,
    loading: getDashboardWidgetDataLoading,
  } = useApi<WidgetResponse>();

  const getAdminDashboardData = async () => {
    setError(null);
    await getAdminDashboardDataRequest("")
      .then((response) => {})
      .catch(setError);
  };

  const getDashboardWidgetData = async () => {
    await getDashboardWidgetDataRequest(
      API_ROUTES.DASHBOARD.base + API_ROUTES.DASHBOARD.admin,
      (response) => {
        const widgets = response as WidgetResponse;
  
        const widgetArray: Widget[] = [
          widgets.appointments,
          widgets.subscriptions,
          widgets.occupancy,
          widgets.earnings,
        ];
  
        const formattedWidgets: DashboardWidget[] = widgetArray.map((widget, index) => {
          const metadata = ADMIN_DASHBOARD_TILES_METADATA[index];
          return {
            ...widget,
            ...metadata,
          };
        });
  
        setDashboardWidgets(formattedWidgets);
      }
    );
  };
  
  
  return {
    loading: getAdminDashboardDataLoading || getDashboardWidgetDataLoading,
    error,
    getAdminDashboardData,
    getDashboardWidgetData,
    dashboardWidgets,
  };
};
export default useDashboard;
